import React from 'react'
// components
import Tooltip from '@mui/material/Tooltip'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// context
import { ApiClientsPageContext } from 'containers/ApiClients/layers/API'
// constants
import { Modals } from 'constants/modals'
// themes
import { TableCell } from 'themes/views/tables'
// types
import { IApiClient } from 'types/graphql'
// views
import { Button, ButtonsWrapper, EditIcon, RevokeIcon } from './views'

interface Props {
  client: IApiClient
  disabled?: boolean
}

const ControlButtons: React.FC<Props> = ({ client, disabled }) => {
  const { revokeApiClient } = React.useContext(ApiClientsPageContext)

  const { showModal: showUpdateModal } = useShowModal({ modalType: Modals.API_CLIENT_UPDATE_MODAL })
  const { showModal: showConfirmModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })

  if (disabled) {
    return <TableCell size={8} />
  }

  const onEditClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    showUpdateModal({ client })
  }

  const onRevokeClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    showConfirmModal({ handleConfirm: () => revokeApiClient(client.id) })
  }

  return (
    <TableCell size={8}>
      <ButtonsWrapper>
        <Tooltip title='Edit'>
          <Button onClick={onEditClick}>
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title='Revoke'>
          <Button onClick={onRevokeClick}>
            <RevokeIcon />
          </Button>
        </Tooltip>
      </ButtonsWrapper>
    </TableCell>
  )
}

export default ControlButtons
